export const PROLONGED_RENTALS_CHART_BACKGROUND_COLOR = '#003594'
export const PROLONGED_RENTALS_CHART_BORDER_COLOR = '#E9ECEF'
export const PROLONGED_RENTALS_CHART_FONT_COLOR = '#ADB5BD'
